<div class="integration-options">

  <div class="integration-loading" *ngIf="loading()">
    <span class="loading-dot pulse-dot"></span>
    <span class="loading-text">CARGANDO PROYECTOS…</span>
  </div>

  <p class="integration-error" *ngIf="!loading() && errorMessage()">
    {{ errorMessage() }}
  </p>

  <ng-container *ngIf="!loading() && !errorMessage()">

    <div class="integration-field" *ngIf="projects().length > 0; else noProjects">
      <label class="field-label" for="gitlab-project">PROYECTO</label>
      <select id="gitlab-project"
              class="field-select"
              [(ngModel)]="selectedProjectId"
              (ngModelChange)="onProjectChange()">
        <option *ngFor="let p of projects()" [ngValue]="p.id">
          {{ p.nameWithNamespace || p.name }}
        </option>
      </select>
    </div>

    <div class="integration-field" *ngIf="projects().length > 0">
      <label class="field-label" for="gitlab-prefix">
        PREFIX TÍTULO <span class="field-hint">(opcional)</span>
      </label>
      <input id="gitlab-prefix"
             type="text"
             class="field-input"
             placeholder="ej. [EST-2026Q2]"
             [(ngModel)]="summaryPrefix"
             (ngModelChange)="onPrefixChange()"
             maxlength="60" />
    </div>

    <ng-template #noProjects>
      <p class="integration-empty">
        Sin proyectos accesibles para tu cuenta.
      </p>
    </ng-template>

  </ng-container>
</div>
